import { format } from 'date-fns'
import React from 'react'

function Hour({
  CELL_HEIGHT,
  h,
  hFormat,
  locale,
}) {
  const hourTypo = format(h, hFormat, { locale })

  return (
    <>
      <span style={{ height: CELL_HEIGHT }} className="rs__cell rs__header rs__time">
        <div className="f-12">{hourTypo}</div>
      </span>
    </>
  )
}

export default Hour
